export { dateToString } from '@jucy/rentals-api-client';
